module.exports = __webpack_public_path__ + "components/flag/static/square/bh-e9df0f58615d9c97b3383907f2cf903a.svg";